import React, { useRef, useLayoutEffect, ReactNode, ComponentType } from 'react';
import { Flush, RibbonProps } from 'domain/constants/ribbons';

import useStylesheet from './Ribbon.stylesheet';
import RibbonImpression from './RibbonImpression';

export { Flush };

interface OuterProps extends RibbonProps {
  children?: ReactNode;
  className?: string | undefined;
}

export const PureRibbon = ({
  children,
  colorway,
  loading,
  layout,
  flush,
  duoLayout,
  id,
  name,
  type,
  className,
}: OuterProps) => {
  const { styles } = useStylesheet({
    colorway,
    loading,
    layout,
    flush,
    duoLayout,
  });
  const targetRef = useRef(null);

  useLayoutEffect(() => {
    // when backstop runs on ribbons, this lets us filter out a lot of false
    // positives and a lot of race condition fails by only initialising
    // the snapshot once loading has finished + a delay to wait for fonts etc to load
    if (process.env.NODE_ENV !== 'production') {
      setTimeout(() => {
        // eslint-disable-next-line no-console
        console.log('BACKSTOP_RIBBON_READY');
      }, 3000);
    }
  }, []);

  return (
    <RibbonImpression className={className} colorway={colorway} id={id} name={name} type={type} style={styles.root}>
      <div style={styles.inner}>
        <div style={styles.ribbon} ref={targetRef}>
          {children}
        </div>
      </div>
    </RibbonImpression>
  );
};

PureRibbon.displayName = 'Ribbon';

export default PureRibbon as ComponentType<OuterProps>;
